import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { FiMapPin, FiArrowLeft, FiSave, FiTrash2 } from 'react-icons/fi';

import { AppContext } from '../AppContext';
import { tre } from '../trebus';

export default function Stop({ creating }) {
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const { id } = useParams();

    const [stop, setStop] = useState({
        id: '',
        name: '',
    });
    const [isLoading, setIsLoading] = useState(!creating);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    // Load stop
    useEffect(() => {
        if (!creating) {
            setIsLoading(true);
            tre.api('GET', `/stops/${id}`, {
                context: context,
                success: (r) => {
                    setStop(r);
                    setIsLoading(false);
                },
                error: () => setIsLoading(false)
            });
        }
    }, [creating, id, context]);

    const handleForm = (ev) => {
        setStop({ ...stop, [ev.target.name]: ev.target.value });
    };

    const save = () => {
        setIsSaving(true);
        if (creating) {
            tre.api('POST', `/companies/${context.user.company_id}/stops`, {
                context: context,
                params: stop,
                success: () => {
                    NotificationManager.success('Parada creada');
                    setIsSaving(false);
                    navigate('/stops');
                },
                error: () => setIsSaving(false)
            });
        } else {
            tre.api('PUT', `/stops/${stop.id}`, {
                context: context,
                params: stop,
                success: () => {
                    NotificationManager.success('Parada modificada');
                    setIsSaving(false);
                },
                error: () => setIsSaving(false)
            });
        }
    };

    const deleteStop = () => {
        if (!window.confirm('¿Estás seguro de eliminar esta parada?')) return;
        setIsDeleting(true);
        tre.api('DELETE', `/stops/${stop.id}`, {
            context: context,
            success: () => {
                NotificationManager.success('Parada eliminada');
                navigate('/stops');
            },
            error: () => setIsDeleting(false)
        });
    };

    // -----| Render |-----
    if (isLoading) {
        return (
            <div className="container py-4" style={{ maxWidth: '700px' }}>
                <div className="text-center py-5">
                    <Spinner animation="border" style={{ color: '#1a73e8' }} />
                    <p className="mt-3 text-muted">Cargando parada...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4" style={{ maxWidth: '700px' }}>
            {/* Header */}
            <div className="d-flex align-items-center mb-4">
                <Button
                    variant="link"
                    onClick={() => navigate('/stops')}
                    className="p-0 me-3"
                    style={{ color: '#5f6368' }}
                >
                    <FiArrowLeft size={24} />
                </Button>
                <div>
                    <h4 className="mb-0" style={{ color: '#202124', fontWeight: 500 }}>
                        <FiMapPin className="me-2" style={{ color: '#1a73e8' }} />
                        {creating ? 'Nueva Parada' : 'Editar Parada'}
                    </h4>
                    {!creating && stop.name && (
                        <small className="text-muted">{stop.name}</small>
                    )}
                </div>
            </div>

            {/* Form Card */}
            <Card className="mb-4">
                <Card.Header className="py-3" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="d-flex align-items-center">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-circle me-3"
                            style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#e8f0fe',
                                color: '#1a73e8'
                            }}
                        >
                            <FiMapPin size={18} />
                        </div>
                        <div>
                            <h6 className="mb-0" style={{ color: '#202124', fontWeight: 500 }}>Información de la Parada</h6>
                            <small className="text-muted">Datos básicos de la parada</small>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body className="p-4">
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, color: '#202124' }}>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={stop.name || ''}
                            onChange={handleForm}
                            placeholder="Nombre de la parada"
                        />
                    </Form.Group>
                </Card.Body>
            </Card>

            {/* Actions */}
            <div className="d-flex justify-content-between">
                <Button
                    variant="light"
                    onClick={() => navigate('/stops')}
                    style={{ padding: '10px 24px' }}
                >
                    Cancelar
                </Button>
                <div className="d-flex gap-2">
                    {!creating && (
                        <Button
                            variant="outline-danger"
                            onClick={deleteStop}
                            disabled={isDeleting}
                            style={{ padding: '10px 24px' }}
                        >
                            {isDeleting ? <Spinner size="sm" className="me-2" /> : <FiTrash2 className="me-2" />}
                            Eliminar
                        </Button>
                    )}
                    <Button
                        variant="primary"
                        onClick={save}
                        disabled={isSaving}
                        style={{ padding: '10px 24px' }}
                    >
                        {isSaving ? <Spinner size="sm" className="me-2" /> : <FiSave className="me-2" />}
                        {creating ? 'Crear Parada' : 'Guardar Cambios'}
                    </Button>
                </div>
            </div>
        </div>
    );
}
